export default __webpack_public_path__ + "static/media/instagram.c75c7c8c.png";